var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-media-share-component",
      attrs: { "data-grm-comp": "RoomMediaShare" },
    },
    [
      _c(
        "div",
        { staticClass: "room-media-share" },
        [
          _c("div", { staticClass: "room-media-share-header" }, [
            _c("div", { staticClass: "room-media-share-info" }, [
              _c("button", {
                staticClass: "room-media-share-button menu",
                on: { click: _vm.onToggleMediaList },
              }),
              _vm.mediaFile
                ? _c("p", { staticClass: "room-media-share-title" }, [
                    _vm._v(_vm._s(_vm.mediaFile.filename)),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "room-media-share-body" }, [
            !_vm.sortedRoomMediaFile(_vm.roomMedia).length
              ? _c(
                  "div",
                  { staticClass: "room-media-share-none-file" },
                  [
                    _c(
                      "p",
                      { staticClass: "room-media-share-none-file-text title" },
                      [_vm._v(_vm._s(_vm.$t("media.share.noFile")))]
                    ),
                    _c(
                      "p",
                      {
                        staticClass:
                          "room-media-share-none-file-text description",
                      },
                      [_vm._v(_vm._s(_vm.$t("media.share.upload.text")))]
                    ),
                    _c(
                      "p",
                      {
                        staticClass:
                          "room-media-share-none-file-text description",
                      },
                      [_vm._v("[" + _vm._s(_vm.$t("media.list.forms")) + "]")]
                    ),
                    _c(
                      "p",
                      {
                        staticClass:
                          "room-media-share-none-file-text description",
                      },
                      [_vm._v("mp3, mp4(H.264), WebM(VP8, VP9), ogg")]
                    ),
                    _vm.hasEmceeRole()
                      ? _c(
                          "GrmBtn",
                          {
                            staticClass: "mt-3",
                            on: { click: _vm.onUploadFile },
                          },
                          [_vm._v(_vm._s(_vm.$t("media.share.upload.btn")))]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isMediaVideo,
                    expression: "isMediaVideo",
                  },
                ],
                staticClass: "room-media-share-video-wrapper",
              },
              [
                _c("video", {
                  ref: "mediaVideo",
                  staticClass: "room-media-share-video",
                  attrs: {
                    "webkit-playsinline": "",
                    playsinline: "",
                    videoplay: "",
                  },
                  on: {
                    error: _vm.eventMedia,
                    durationchange: _vm.eventMedia,
                    resize: _vm.eventMedia,
                    canplay: _vm.eventMedia,
                    play: _vm.eventMedia,
                    playing: _vm.eventMedia,
                    pause: _vm.eventMedia,
                    seeked: _vm.eventMedia,
                    ended: _vm.eventMedia,
                  },
                }),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isMediaAudio,
                    expression: "isMediaAudio",
                  },
                ],
                staticClass: "room-media-share-video-wrapper",
              },
              [
                _c("audio", {
                  ref: "mediaAudio",
                  staticClass: "room-media-share-audio",
                  attrs: { "webkit-playsinline": "" },
                  on: {
                    error: _vm.eventMedia,
                    durationchange: _vm.eventMedia,
                    resize: _vm.eventMedia,
                    canplay: _vm.eventMedia,
                    play: _vm.eventMedia,
                    playing: _vm.eventMedia,
                    pause: _vm.eventMedia,
                    seeked: _vm.eventMedia,
                    ended: _vm.eventMedia,
                  },
                }),
              ]
            ),
          ]),
          !!_vm.roomMedia.mediaId
            ? _c("div", { staticClass: "room-media-share-bottom" }, [
                _c("div", { staticClass: "room-media-share-controls" }, [
                  _c("button", {
                    staticClass: "room-media-share-control-button",
                    class: [
                      _vm.roomMedia.playState === "play" ? "pause" : "play",
                    ],
                    on: { click: _vm.changeMediaPlayState },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "room-media-share-control-range",
                      class: { "pl-3": !_vm.hasEmceeRole() },
                    },
                    [
                      _c("GrmSlider", {
                        attrs: { value: _vm.mediaTimeRange, max: _vm.rangeMax },
                        on: {
                          input: _vm.updateTempSeekTime,
                          touchstart: function ($event) {
                            _vm.isStartChangeMediaTime = true
                          },
                          touchend: _vm.changeTempSeekTime,
                          pointerdown: function ($event) {
                            _vm.isStartChangeMediaTime = true
                          },
                          pointerup: _vm.changeTempSeekTime,
                          mousedown: function ($event) {
                            _vm.isStartChangeMediaTime = true
                          },
                          mouseup: _vm.changeTempSeekTime,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "room-media-share-control-time-container" },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "room-media-share-control-time current",
                        },
                        [_vm._v(_vm._s(_vm.mediaPlayTime))]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "room-media-share-control-time duration",
                        },
                        [_vm._v(_vm._s(_vm.mediaPlayDuration))]
                      ),
                    ]
                  ),
                  _c("button", {
                    staticClass: "room-media-share-control-button speaker",
                    class: [_vm.isMuted ? "off" : "on"],
                    on: { click: _vm.toggleVolume },
                  }),
                  !_vm.Device.isIOSSafari()
                    ? _c(
                        "div",
                        {
                          staticClass: "room-media-share-control-range volume",
                        },
                        [
                          _c("GrmSlider", {
                            attrs: {
                              value: _vm.currentPlayer?.volume,
                              max: 1,
                              step: 0.1,
                            },
                            on: { input: _vm.changeVolume },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _c("RoomMediaList", {
            class: { show: _vm.isShowMediaList },
            attrs: { roomGroupId: _vm.roomGroupId },
            on: {
              onToggleMediaList: _vm.onToggleMediaList,
              reqUploadMediaFile: _vm.onUploadFile,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }